/**
 * Shared utility for building OCC-format option symbols for Schwab API.
 * SPX orders always use the SPXW root — the bare SPX root resolves to the
 * AM-settled monthly contract, which we never trade.
 */

export function buildOCCSymbol(underlying, expiration, putCall, strike) {
  const d = new Date(expiration + 'T00:00:00');
  const yy = String(d.getFullYear()).slice(2);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const strikeStr = String(Math.round(strike * 1000)).padStart(8, '0');

  const root = underlying === 'SPX' ? 'SPXW' : underlying;

  const paddedUnderlying = root.padEnd(6, ' ');
  return `${paddedUnderlying}${yy}${mm}${dd}${putCall}${strikeStr}`;
}

export function roundSPXTo5Cents(price, isBuy, symbol) {
  if (price == null) return price;
  const sym = String(symbol || '').replace(/\s+/g, '').toUpperCase();
  if (!/^(\$?SPX|SPXW)/.test(sym)) return price;
  const ticks = price * 20;
  return isBuy ? Math.ceil(ticks) / 20 : Math.floor(ticks) / 20;
}
